"use strict";exports.__esModule = true;exports.isInstanceOf = isInstanceOf;function isInstanceOf(
instance,
constructor)
{
  return !!constructor && instance instanceof constructor;
}